export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

export const GRID_SIZE = 3;

// Protest/"judge" mode is hidden from public view pending a rework
// (unreliable LLM verdicts; should hard-reject non-words). Code and the
// /api/protest backend stay intact — set REACT_APP_ENABLE_PROTESTS=true
// to bring the UI back without a code change.
export const ENABLE_PROTESTS = process.env.REACT_APP_ENABLE_PROTESTS === 'true';
